type MaybeDate = Date | string | number | null | undefined;

const pad2 = (value: number) => String(value).padStart(2, '0');

const toDate = (value: MaybeDate): Date | null => {
  if (!value) {
    return null;
  }
  if (value instanceof Date) {
    return value;
  }
  const parsed = new Date(value);
  return Number.isNaN(parsed.getTime()) ? null : parsed;
};

export const formatDate = (value: MaybeDate): string => {
  const date = toDate(value);
  if (!date) return '-';
  return `${date.getFullYear()}/${pad2(date.getMonth() + 1)}/${pad2(date.getDate())}`;
};

export const formatDateTime = (value: MaybeDate): string => {
  const date = toDate(value);
  if (!date) return '-';
  return `${formatDate(date)} ${pad2(date.getHours())}:${pad2(date.getMinutes())}`;
};

